/*
 * @Author: luting
 * @Date: 2022-04-09 11:08:47
 * @lastEditors: luting
 * @LastEditTime: 2023-02-27 08:52:08
 */
import React from 'react';
import { Checkbox, Radio } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from '../messages';
import style from './index.less';
import classnames from 'classnames';

import CommonEmpty from 'root/components/CommonEmpty';

import { SelectDiskListDataType } from 'root/pages/DiskConfig/diskTypes';

export interface ISelectDiskType {
  setSelectDiskKeys?: any;
  selectDiskKeys?: string[];
  diskListData: SelectDiskListDataType[];
  vginfoData?: any[];
  setVginfoSize?: any;
  setPartitionType?: any;
  partitionType?: number;
  setVgname?: any;
  vgName?: string;
}

const SelectDisk: React.FC<ISelectDiskType> = (props) => {
  const {
    diskListData,
    setSelectDiskKeys,
    selectDiskKeys,
    vginfoData,
    setVginfoSize,
    setPartitionType,
    partitionType,
    setVgname,
    vgName,
  } = props;
  const intl = useIntl();

  const onChange = (checkedValues: string[]) => {
    // 将选择的checkedValues传给父组件
    setSelectDiskKeys(checkedValues);
  };

  const renderDiskItem = (item: SelectDiskListDataType) => {
    return (
      <div className={style.chooseDisk} key={item.name}>
        <Checkbox value={item.path} disabled={partitionType === 2} />
        <div className={style.diskInfo}>
          <p className={style.diskName}>{item.name}</p>
          <div className={style.diskDetail}>
            <div className={style.disFirstDetail}>
              <div className={style.diskDetailTitle}>{intl.formatMessage(messages.status)}</div>
              <div className={style.diskDetailContentFont}>
                {intl.formatMessage(item.status ? messages.used : messages.unUse)}
              </div>
            </div>
            <div>
              <div className={style.diskDetailTitle}>{intl.formatMessage(messages.capacity)}</div>
              <div className={style.diskDetailContentNumber}>
                {item.size}
                <span className={style.unit}>GB</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 选择创建环境方式
  const typeChange = (ele: any) => {
    setPartitionType(ele?.target?.value);
  };

  // 选择卷组的选项
  const vginfoItemChange = (ele: any) => {
    setVgname(ele?.target?.value?.name);
    setVginfoSize(ele?.target?.value?.leftSize);
  };

  const renderVginfoItem = (item: any) => {
    const { name, totalSize, leftSize } = item;
    // const disabled = leftSize < 400;  // 3.27  4.2.1版本修改需求为暂不限制所选磁盘空间
    const disabled = false;
    return (
      <Radio
        value={item}
        disabled={disabled}
        className={classnames(
          style.vginfoItem,
          { [`${style.select}`]: name === vgName },
          { [`${style.disabled}`]: disabled },
        )}
      >
        <div>
          <div>
            <span className={style.title}>{name}</span>
            {disabled && <span className={style.error}>{intl.formatMessage(messages.sizeTip)}</span>}
          </div>
          <div>
            <p className={style.count}>
              {intl.formatMessage(messages.leftSize)}
              <span className={disabled ? `${style.error}` : ''}> {leftSize}GB</span>
            </p>
            <p className={style.count}>
              {intl.formatMessage(messages.totalSize)}
              <span> {totalSize}GB</span>
            </p>
          </div>
        </div>
      </Radio>
    );
  };
  return partitionType ? (
    <Radio.Group onChange={typeChange} value={partitionType}>
      <Radio value={1}>
        <span className={style.radioText}>{intl.formatMessage(messages.inNewVolumeGroup)}</span>
        <span className={style.multipleChoices}> ({intl.formatMessage(messages.multipleChoices)})</span>
      </Radio>
      {diskListData.length ? (
        <Checkbox.Group value={selectDiskKeys} style={{ width: '100%' }} onChange={onChange}>
          <div className={style.diskBox} style={partitionType === 1 ? {} : { opacity: 0.5 }}>
            {diskListData.map((item) => renderDiskItem(item))}
          </div>
        </Checkbox.Group>
      ) : (
        <CommonEmpty content={intl.formatMessage(messages.cannotFindDisk)} />
      )}

      <Radio value={2}>
        <span className={style.radioText}>{intl.formatMessage(messages.inExistingVolumeGroup)}</span>
      </Radio>
      <Radio.Group onChange={vginfoItemChange} style={{ width: '100%' }}>
        {vginfoData && (
          <div className={style.vginfoBox}>
            {vginfoData.map((item) => renderVginfoItem(item))}
            {partitionType === 1 && <div className={style.mask} />}
          </div>
        )}
      </Radio.Group>
    </Radio.Group>
  ) : (
    <div style={{ height: '100%' }}>
      {diskListData.length ? (
        <Checkbox.Group value={selectDiskKeys} style={{ width: '100%' }} onChange={onChange}>
          <div className={style.diskBox}>{diskListData.map((item) => renderDiskItem(item))}</div>
        </Checkbox.Group>
      ) : (
        <CommonEmpty content={intl.formatMessage(messages.cannotFindDisk)} />
      )}
    </div>
  );
};

export default SelectDisk;
